import { useState } from 'react';

const useManualInvoiceForm = (onSubmit) => {
  const [formData, setFormData] = useState({
    supplierNumber: '',
    supplierName: '',
    companyName: '',
    companyId: '',
    invoiceNumber: '',
    invoiceDate: '',
    allocationNumber: '',
    currencyCode: 'ILS',
    items: [],
    subtotal: '',
    vatAmount: '',
    total: ''
  });

  const [pdfFile, setPdfFile] = useState(null);
  const [errors, setErrors] = useState({});

  const handleChange = (field) => (event) => {
    setFormData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const handleFileChange = (file) => {
    if (file) {
      const validTypes = ['application/pdf'];
      if (!validTypes.includes(file.type)) {
        setErrors(prev => ({ ...prev, pdfFile: 'יש להעלות קובץ PDF בלבד' }));
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        setErrors(prev => ({ ...prev, pdfFile: 'גודל הקובץ לא יכול לעבור 10MB' }));
        return;
      }
      setPdfFile(file);
      setErrors(prev => ({ ...prev, pdfFile: '' }));
    }
  };

  const handleRemoveFile = () => {
    setPdfFile(null);
  };

  const addItem = () => {
    setFormData(prev => ({
      ...prev,
      items: [
        ...prev.items,
        {
          code: '',
          description: '',
          quantity: '',
          unitPrice: '',
          exchangeRate: '1',
          total: ''
        }
      ]
    }));
  };

  const removeItem = (index) => {
    setFormData(prev => ({
      ...prev,
      items: prev.items.filter((_, i) => i !== index)
    }));
  };

  const updateItem = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      items: prev.items.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.supplierName.trim()) {
      newErrors.supplierName = 'שם ספק הוא שדה חובה';
    }

    if (!formData.companyName.trim()) {
      newErrors.companyName = 'שם חברה הוא שדה חובה';
    }

    if (!formData.invoiceNumber.trim()) {
      newErrors.invoiceNumber = 'מספר חשבונית הוא שדה חובה';
    }

    if (!formData.invoiceDate) {
      newErrors.invoiceDate = 'תאריך חשבונית הוא שדה חובה';
    } else {
      const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
      if (!dateRegex.test(formData.invoiceDate)) {
        newErrors.invoiceDate = 'פורמט תאריך לא תקין (dd/mm/yyyy)';
      }
    }

    if (!formData.subtotal || parseFloat(formData.subtotal) < 0) {
      newErrors.subtotal = 'סה"כ לפני מע"מ חייב להיות מספר חיובי';
    }

    if (!formData.vatAmount || parseFloat(formData.vatAmount) < 0) {
      newErrors.vatAmount = 'מע"מ חייב להיות מספר חיובי';
    }

    if (!formData.total || parseFloat(formData.total) <= 0) {
      newErrors.total = 'סה"כ כולל מע"מ חייב להיות מספר חיובי';
    }

    if (formData.companyId && !/^\d{9}$/.test(formData.companyId)) {
      newErrors.companyId = 'ח.פ חייב להכיל 9 ספרות';
    }

    if (formData.items.length === 0) {
      newErrors.items = 'יש להוסיף לפחות שורה אחת';
    }

    formData.items.forEach((item, index) => {
      if (!item.description.trim()) {
        newErrors[`item_${index}_description`] = 'תיאור חובה';
      }
      if (!item.quantity || parseFloat(item.quantity) <= 0) {
        newErrors[`item_${index}_quantity`] = 'כמות חובה';
      }
      if (!item.unitPrice || parseFloat(item.unitPrice) < 0) {
        newErrors[`item_${index}_unitPrice`] = 'מחיר חובה';
      }
      if (!item.total || parseFloat(item.total) < 0) {
        newErrors[`item_${index}_total`] = 'סה"כ חובה';
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const submitData = {
        ...formData,
        subtotal: parseFloat(formData.subtotal),
        vatAmount: parseFloat(formData.vatAmount),
        total: parseFloat(formData.total),
        items: formData.items.map(item => ({
          code: item.code,                    
          description: item.description,
          quantity: parseFloat(item.quantity),
          unitPrice: parseFloat(item.unitPrice), 
          exchangeRate: parseFloat(item.exchangeRate),
          total: parseFloat(item.total)
        }))
      };

      await onSubmit(submitData, pdfFile);
    }
  };

  return {
    formData,
    pdfFile,
    errors,
    handleChange,
    handleFileChange,
    handleRemoveFile,
    addItem,
    removeItem,
    updateItem,
    handleSubmit
  };
};

export default useManualInvoiceForm;